import './styles.css';
import 'iconify-icon';
import { displayData, setupAppListeners } from './display-weather-data';

// Init
setupAppListeners();
displayData();
